module.exports = __webpack_public_path__ + "img/ls_check_1.3b6ca960.png";